// extracted by mini-css-extract-plugin
export var activityContainer = "_nn-0";
export var typingIndicatorContainer = "_nn-1";
export var typingIndicatorDot = "_nn-2";
export var wave = "_nn-3";